import { render, staticRenderFns } from "./ChooseStudentForm.vue?vue&type=template&id=76ddedfb&scoped=true"
import script from "./ChooseStudentForm.vue?vue&type=script&lang=js"
export * from "./ChooseStudentForm.vue?vue&type=script&lang=js"
import style0 from "./ChooseStudentForm.vue?vue&type=style&index=0&id=76ddedfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ddedfb",
  null
  
)

export default component.exports